const alignment = {
  state: {
    fileNumber: 2,
    fileList: [],
    sourceLang: "",
    targetLang: "",
    isSent: sessionStorage.getItem("isSent") || "",
  },
  mutations: {
    CHANGE_FILE_NUMBER(state, payload) {
      state.fileNumber = payload
    },
    SAVE_FILE_LIST(state, payload) {
      console.log(payload,'@##$');
      if (!payload) {
        state.fileList = payload
        return
      }
      if (Array.isArray(payload) && payload.length) {
        state.fileList = payload
        sessionStorage.setItem("myFileList", JSON.stringify(state.fileList))
        return;
      }
      let arr;
      if (!state.fileList) {
        arr = []
        arr.push(payload);
        state.fileList = arr;
        return;
      }

      state.fileList = state.fileList.filter(item => {
        return item.uploadType !== payload.uploadType
      })
      state.fileList.push(payload)
      sessionStorage.setItem("myFileList", JSON.stringify(state.fileList))
    },
    REMOVE_FILE_LIST(state) {
      if (state.fileList && state.fileList.length) {
        state.fileList = state.fileList.filter(item => {
          return item.uploadType === "source"
        })
        sessionStorage.setItem("myFileList", JSON.stringify(state.fileList))
      }
    }
    ,
    SET_IS_SENT(state) {
      state.isSent = JSON.parse(sessionStorage.getItem("isSent")) || ""
    },
    SET_SOURCE_LANG(state, payload) {
      state.sourceLang = payload
      if (payload){
        sessionStorage.setItem("sourceLang", payload)
      }
    },
    SET_TARGET_LANG(state, payload) {
      state.targetLang = payload
      if (payload){
      sessionStorage.setItem("targetLang", payload)
      }
    },
    DELETE_FILE_LIST(state) {
      state.fileList.pop();
    },
  },
  actions: {
    changeFileNumber({ commit }, data) {
      commit("CHANGE_FILE_NUMBER", data)
    },
    saveFileList({ commit }, data) {
      // console.log(data,"data")
      commit("SAVE_FILE_LIST", data)
    },
    deleteFileList({ commit }) {
      commit("DELETE_FILE_LIST")
    },
    removeFileList({ commit }) {
      commit("REMOVE_FILE_LIST")
    },
    removesetisSent({ commit }, data) {
      commit('SET_IS_SENT', data)
    }
  },
  getters: {
    fileList(state) {
      return state.fileList
    },
    sourceLang(state) {
      return state.sourceLang
    },
    targetLang(state) {
      return state.targetLang
    },
  }
}
export default alignment
